import Vue from 'vue';
import Vuex from 'vuex';
// import router from '@/router';
import { loadFetch, /* buidlURL, GATEWAY, */ reachGoal } from '@/functions';

Vue.use(Vuex);

const state = {
  types: [],
  countries: [],
  allTours: [],
  tours: [],
  departure: null,
  type: null,
  country: null,
  tour: null,
  mode: 'max',
  isTourCountLimited: true,

  offices: null,
  city: null,
  context: null,

  feedback: {
    office: null,
    username: '',
    email: '',
    phone: '',
    adding: ''
  },
  sent: false,

  loading: [],
  errors: []
};

const getters = {
  context: state => {
    // return 'well.ru';
    if (state && state.context) return state.context;
    //eslint-disable-next-line
    const origin =
      process.env.NODE_ENV !== 'production'
        ? 'https://site.turdoka.ru'
        : window.location.origin;
    let result;
    switch (true) {
      case origin === 'https://well.ru':
        result = 'main';
        break;
      case origin === 'https://putevkamarket.ru':
        result = 'main-pm';
        break;
      case origin === 'https://office.well.ru':
      case origin === 'https://agent.putevkamarket.ru':
        result = 'office';
        break;
      case origin.search('.well.ru') !== -1:
        result = 'well';
        break;
      case origin.search('.putevkamarket.ru') !== -1:
        result = 'pm';
        break;
      case origin.search('.turdoka.ru') !== -1:
        result = 'td';
        break;
      default:
        result = 'well';
        break;
    }
    return result;
  },
  policyPageLink: getters => {
    switch (getters.context) {
      case 'main':
        return 'https://well.ru/about/acceptance_personal_data.php';
      case 'main-pm':
        return 'https://putevkamarket.ru/politiki-konfidencialnosti/';
      default:
        return '/kontakty/personal_data_acceptance/';
    }
  },
  isError: state => code =>
    !code ? state.errors.length > 0 : state.errors.includes(code),
  isLoading: state => code =>
    !code ? state.loading.length > 0 : state.loading.includes(code),
  countriesByType: state =>
    state.type
      ? state.countries.filter(country =>
        [
          ...new Set(
            state.tours
              .filter(tour => tour.types.includes(state.type))
              .map(tour => tour.country_id)
          )
        ].includes(country.id)
      )
      : state.countries,
  toursByTypeByCountry: state =>
    state.tours
      .filter(
        tour =>
          tour.types.includes(state.type) &&
          (state.country ? tour.country_id === state.country : true)
      )
      .sort((a, b) => a.price.replace(' ', '') - b.price.replace(' ', '')),
  currencyString: () => price =>
    `${price} <span class="wspo-small">руб.</span>`,
  typeString: state => {
    switch (state.type) {
      case '4317':
        return 'горнолыжные';
      case '4319':
        return 'экскурсионные';
      case '4325':
        return 'лечебные';
      case '4316':
      default:
        return 'пляжные';
    }
  },
  countryString: state =>
    state.country
      ? `в страну <span class="wspo-main-title-accent">${state.countries.find(c => c.id === state.country).name
      }</span>`
      : 'в <span class="wspo-main-title-accent">любую</span> страну',
  netCities: state => {
    if (!state.offices) return [];
    return state.offices.cities;
  },
  netOffices: state => {
    if (!state.offices) return [];
    if (!state.city) return state.offices.agencies;
    return state.offices.agencies.filter(agency => agency.city === state.city);
  }
};

const mutations = {
  setTourCountUnlimited(state) {
    state.isTourCountLimited = false;
  },
  setLoading(state, { text, set = true }) {
    if (set) {
      state.errors = [];
      state.loading.push(text);
    } else state.loading.splice(state.loading.indexOf(text), 1);
  },
  setError(state, error) {
    state.errors.push(error);
  },
  setInitials(state, initials) {
    state.countries = Object.entries(initials.countries)
      .map(row => ({
        id: row[0],
        name: row[1]
      }))
      .sort((a, b) => (a.name < b.name ? -1 : a.name > b.name ? 1 : 0));
    state.types = Object.entries(initials.types).map(row => ({
      id: row[0],
      name: row[1]
    }));
    state.allTours = initials.tours;
    state.departures =
      initials.departures.length > 0
        ? initials.departures.map(d => ({
          id: d,
          name: initials.cities[d]
        }))
        : Object.entries(initials.cities)
          .map(row => ({
            id: row[0],
            name: row[1]
          }))
          .sort((a, b) =>
            b.name === 'Москва' || b.name < a.name
              ? 1
              : b.name > a.name
                ? -1
                : 0
          );
    state.departure =
      initials.departures.length > 0
        ? initials.departures.includes('1242326')
          ? '1242326'
          : initials.departures[0]
        : state.departures[0].id;
    state.tours = initials.tours
      .map(t => {
        const flightFound = t.flights.find(f => f.departure == state.departure);
        if (flightFound)
          return {
            ...t,
            ...flightFound
          };
        else return false;
      })
      .filter(t => t);
    state.type = state.types[0].id;
    state.context = initials.context;
    // state.country = state.countries[0].id;
    // state.country = '1873';
  },
  setType(state, id) {
    state.type = id;
    state.country = null;
  },
  setCountry(state, id) {
    state.country = id;
  },
  setDeparture(state, id) {
    state.departure = id;
    state.tours = state.allTours
      .map(t => {
        const flightFound = t.flights.find(f => f.departure == id);
        if (flightFound)
          return {
            ...t,
            ...flightFound
          };
        else return false;
      })
      .filter(t => t);
  },
  setMode(state, mode) {
    if (state.mode === mode) return;
    state.mode = mode;
    state.country = null;
  },
  setTour(state, id) {
    state.tour = id;
  },
  updateFeedback(state, feedback) {
    state.feedback = { ...state.feedback, ...feedback };
  },
  setSent(state, sent = true) {
    state.sent = sent;
  },
  updateOfficeList(state, offices) {
    state.offices = {
      cities: Object.entries(offices.CITIES)
        .map(row => ({
          id: row[0],
          name: row[1].NAME
        }))
        .sort((a, b) => (a.name < b.name ? -1 : a.name > b.name ? 1 : 0)),
      agencies: Object.entries(offices.TO)
        .map(row => ({
          id: row[0],
          city: row[1].CITY,
          name: row[1].NAME,
          code: row[1].CODE
        }))
        .sort((a, b) => (a.name < b.name ? -1 : a.name > b.name ? 1 : 0))
    };
  },
  updateCity(state, city) {
    state.city = city;
  }
};

const actions = {
  initialize({ commit, state, dispatch }) {
    // router.onReady(() => {
    //   loadFetch(commit, 'Initialization', { type: 'spo' }, response => {
    //     commit('setInitials', response);
    //   });
    // });
    return loadFetch(commit, 'Initialization', { type: 'spo' }, response => {
      if (response.Error) return commit('setError', response.Error);

      commit('setInitials', response);

      const tourID = new URLSearchParams(location.search).get('spo');
      if (tourID) {
        const tourFound = state.allTours.find(t =>
          t.flights.find(f => f.id === tourID)
        );
        if (tourFound) {
          const flightFound = tourFound.flights.find(f => f.id === tourID);

          if (flightFound) {
            commit('setDeparture', flightFound.departure);
            commit('setTour', tourID);
          }
        }
      }
    }).then(() => dispatch('getOfficeList'));
  },
  sendFeedback({ state, getters, commit }) {
    const params = {
      type: 'spo-feedback',
      tour: state.tour,
      ...state.feedback
    };
    if (['pm', 'main-pm'].includes(getters.context)) params.tvnet = 'pm';

    // console.log(params);

    // return;
    // eslint-disable-next-line
    return loadFetch(commit, 'Actualizing tour details', params, response => {
      if (response.status === 'error' || response.Error)
        commit(
          'setError',
          'Ошибка! Перезагрузите страницу и попробуйте еще раз'
        );
      if (response.status === 'success' || response.Success) {
        commit('setSent');
        setTimeout(() => commit('setSent', false), 5000);
      }
      // console.log(state.sent);
      if (response.ym) reachGoal(response.ym, 'tourOrder');
    });
  },
  getOfficeList({ commit, getters }) {
    const params = { type: 'officelist' };
    if (getters.context === 'main-pm') params.tvnet = 'pm';
    return loadFetch(commit, 'Getting offices', params, response => {
      commit('updateOfficeList', response.LISTS);
    });
  }
};

export default new Vuex.Store({
  state,
  getters,
  mutations,
  actions
});
